import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "location-autocomplete__shell" }
const _hoisted_2 = ["placeholder", "value"]
const _hoisted_3 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["location-autocomplete", _ctx.wrapperClass])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("input", _mergeProps({
        ref: "inputRef",
        type: "text",
        class: _ctx.inputClass,
        placeholder: _ctx.inputPlaceholder,
        value: _ctx.inputValue,
        onFocus: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFocus && _ctx.handleFocus(...args))),
        onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
        onKeydownCapture: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleKeydown && _ctx.handleKeydown(...args))),
        autocomplete: "off"
      }, _ctx.inputAttrs), null, 16, _hoisted_2),
      (_ctx.inputValue)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "location-autocomplete__clear",
            "aria-label": _ctx.translate('Clear location'),
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearSelection && _ctx.clearSelection(...args)))
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
          ]))], 8, _hoisted_3))
        : _createCommentVNode("", true)
    ])
  ], 2))
}